<template>

  <li :class="[{open:item.open}, 'item-' + item.id]">
    <button v-if="!item.link" ref="btn" class="head" @click="clickListItem()" tabindex="0">
      <div class="txt">
        <span class="title" v-html="item.title"></span>
        <span v-if="item.subTitle" class="descr" v-html="item.subTitle"></span>
      </div>
      <i class="icon" v-show="!item.open" :class="item.icon"></i>
      <i class="icon" v-show="item.open" :class="item.iconActive"></i>
    </button>

    <a v-if="item.link" ref="btn" class="head" target="_blank" :href="item.link" tabindex="0">
      <div class="txt">
        <span class="title" v-html="item.title"></span>
        <span v-if="item.subTitle" class="descr" v-html="item.subTitle"></span>
      </div>
      <i class="icon" v-show="!item.open" :class="item.icon"></i>
      <i class="icon" v-show="item.open" :class="item.iconActive"></i>
    </a>




    <div class="body" >
      <div class="info">
        <div v-html="item.descr"></div>
      </div>
    </div>
  </li>
</template>

<script>


export default {
  props: [
    'item',
  ],
  data() {
    return {

    }
  },
  computed: {

    termId() {
      return this.item.terms.length ? this.item.terms[0].term_id : false;
    },
    itemOpen() {
    //  return this.item.id === this.$store.state.currentGarbage;
    },

  },
  methods: {

    clickListItem() {
      let vm = this;
      this.$emit('itemclick', this.item);
    },
  },
  mounted: function () {

  },
  created: function () {

  },
  components: {},
}
</script>

<style scoped>
</style>